import { render, staticRenderFns } from "./CustomerTipModal.vue?vue&type=template&id=2474af22&"
import script from "./CustomerTipModal.vue?vue&type=script&lang=js&"
export * from "./CustomerTipModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTipModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports